import { timeFrameMap } from "../../../../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setupFilters/setupFiltersModules/ftfc/timeFrameMap";

type Direction = {
  bothDirections: boolean,
  direction: string | null,
  timeFrameArray: string[]
}
type FTFCObject = {
  status: boolean,
  details: Direction
}

export function ftfcFilterParser(_root:any, softOrder:any): FTFCObject {
  const tacticValue = softOrder.value.tacticValue;
  const timeFrameArray = [];
  let bothDirections = true;
  let direction = null;
  if (!tacticValue.long || !tacticValue.short) bothDirections = false;
  let passFilter:boolean = true;
  if (bothDirections) {
    let longTrue = true;
    let shortTrue = true;
    for (const duration of tacticValue.long) {
      timeFrameArray.push(`${duration.candleDuration}${timeFrameMap[duration.timeUnit]}`)
      if (duration.achievedTimeFrame === false) {
        longTrue = false;
      }
    }
    for (const duration of tacticValue.short) {
      if (duration.achievedTimeFrame === false) {
        shortTrue = false;
        break;
      }
    }
    if (!longTrue && !shortTrue) passFilter = false;
    else {
      if (!longTrue) direction = 'short';
      else direction = 'long';
    }
  } else {
    if (tacticValue.long) {
      for (const duration of tacticValue.long) {
        timeFrameArray.push(`${duration.candleDuration}${timeFrameMap[duration.timeUnit]}`)
        if (duration.achievedTimeFrame === false) {
          passFilter = false;
        }
      }
      direction = 'long';
    } else {
      for (const duration of tacticValue.short) {
        timeFrameArray.push(`${duration.candleDuration}${timeFrameMap[duration.timeUnit]}`)
        if (duration.achievedTimeFrame === false) {
          passFilter = false;
        }
      }
      direction = 'short';
    }
  }
  return {
    status: passFilter,
    details: {
      bothDirections,
      direction,
      timeFrameArray,
    },
  };
}

// {
//   "messageType": "softOrder",
//   "tradePlanId": 1643228936828,
//   "tradePlanType": "ALERT",
//   "value": {
//       "timeStamp": "1643228940083",
//       "tacticId": "AMDFTFC_FILTER16432289368282",
//       "tactic": "FTFC_FILTER",
//       "symbol": "AMD",
//       "tacticValue": {
//           "long": [
//               {
//                   "priceToBreak": 100.4,
//                   "candleDuration": 1,
//                   "timeUnit": "MINUTES",
//                   "achievedTimeFrame": false
//               },
//               {
//                   "priceToBreak": 100.4,
//                   "candleDuration": 5,
//                   "timeUnit": "MINUTES",
//                   "achievedTimeFrame": false
//               },
//               {
//                   "priceToBreak": 100.2,
//                   "candleDuration": 1,
//                   "timeUnit": "DAYS",
//                   "achievedTimeFrame": false
//               }
//           ]
//       }
//   }
// }
